import React, { useState } from 'react';
import AdminSidebar from '../../components/ui/AdminSidebar';
import Icon from '../../components/AppIcon';
import PaymentHistoryTab from './components/PaymentHistoryTab';
import TransactionsTab from './components/TransactionsTab';
import RefundsTab from './components/RefundsTab';
import InvoicesTab from './components/InvoicesTab';

const PaymentManagementCenter = () => {
  const [activeTab, setActiveTab] = useState('payment-history');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const tabs = [
    { id: 'payment-history', label: 'Payment History', icon: 'History' },
    { id: 'transactions', label: 'Transactions', icon: 'ArrowLeftRight' },
    { id: 'refunds', label: 'Refunds', icon: 'RotateCcw' },
    { id: 'invoices', label: 'Invoices', icon: 'FileText' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'payment-history':
        return <PaymentHistoryTab />;
      case 'transactions':
        return <TransactionsTab />;
      case 'refunds':
        return <RefundsTab />;
      case 'invoices':
        return <InvoicesTab />;
      default:
        return <PaymentHistoryTab />;
    }
  };

  return (
    <div className="flex min-h-screen bg-background">
      <AdminSidebar isCollapsed={sidebarCollapsed} />
      <div className={`flex-1 transition-smooth ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
        <div className="p-4 md:p-6 lg:p-8">
          {/* Header */}
          <div className="mb-6">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground font-heading flex items-center gap-3">
              <Icon name="Wallet" size={32} className="text-primary" />
              Payment Management Center
            </h1>
            <p className="text-sm md:text-base text-muted-foreground font-body mt-2">
              Track payments, transactions, refunds, and invoices
            </p>
          </div>

          {/* Tabs Navigation */}
          <div className="mb-6 border-b border-border overflow-x-auto">
            <div className="flex gap-2 min-w-max">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 px-4 py-3 text-sm font-medium transition-smooth border-b-2 whitespace-nowrap ${
                    activeTab === tab?.id
                      ? 'border-primary text-primary bg-primary/5' :'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon name={tab?.icon} size={18} />
                  <span className="hidden sm:inline">{tab?.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Tab Content */}
          <div className="transition-smooth">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentManagementCenter;